var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('field-label',{attrs:{"field":_vm.field}}),_c('v-text-field',{attrs:{"value":_vm.value,"rules":_vm.rules,"disabled":_vm.field.disabled,"outlined":"","dense":""},on:{"input":_vm.input}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }